export default [
  {
    channelName: "ABC Community",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Public",
    statusType: "kotakblue",
    totalMember: "40"
  },
  {
    channelName: "CDF Community",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Private",
    statusType: "primary",
    totalMember: "43"
  },
  {
    channelName: "XYZ Community",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Private",
    statusType: "primary",
    totalMember: "50"
  },
  {
    channelName: "PQR Community",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Public",
    statusType: "kotakblue",
    totalMember: "30"
  }
];
